<template>
    <div v-if="backdrop">
      <div
        class="modal fade"
        :class="modal.open ? 'show' : ''"
        style="display: block"
        tabindex="-1"
        role="dialog"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <div class="py-3">
                <h5 class="modal-title">Beberapa Data Tidak Dapat Diproses</h5>
                <p class="mb-0">Silakan unduh data yang tidak terproses, perbarui kolom yang diperlukan, dan unggah ulang file yang telah diperbaiki.</p>
              </div>
              <button type="button" class="close" @click="resetData()" v-html="ic('close')"/>
            </div>
  
            <form @submit.prevent="submit">
              <div class="modal-body m-0 p-0">
                <table class="table table-responsive mb-0">
                  <thead class="sticky-header">
                    <tr>
                      <th v-for="header in csvHeaders" :key="header">{{ header }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(row, index) in csvData">
                      <tr :key="'row-' + index">
                        <td v-for="(value, key) in row" v-if="key !== 'error'" :key="'col-' + key">
                        {{ value }}
                        </td>
                      </tr>
                      <tr v-if="row.error" :key="'error-' + index" class="text-danger" :style="{ backgroundColor: '#f5f7e6' }">
                        <td :colspan="csvHeaders.length">
                        ⚠ Errors: {{ row.error }}
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
  
              <div class="modal-footer pt-2">
                <button type="button" class="btn btn-primary" @click="exportData()" v-html="'Download Unprocessed Data'" />
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="modal-backdrop fade" :class="modal.open ? 'show' : ''" />
    </div>
  </template>
  
  <script>
  import helper from "@/assets/js/helper.js";
  
  export default {
    name: "FailedImported",
    props: {
      config: {
        view: false,
      },
      csvHeaders: [],
      csvData: [],
      resetData: Function,
      exportData: Function,
    },
  
    mixins: [helper],
  
    data() {
      return {
        backdrop: false,
        modal: {
          open: false,
        },
      };
    },
  
    methods: {},
  
    watch: {
      "config.view": function(view) {
        if (view) {
          this.backdrop = true;
          setTimeout(() => {
            this.modal.open = view;
          }, 100);
        } else {
          this.modal.open = view;
  
          setTimeout(() => {
            this.backdrop = view;
          }, 100);
        }
      },
    }
  };
</script>
<style scoped>
.sticky-header {
  position: sticky;
  top: 0;
  background: #f6f7f7;
  z-index: 1000;
}
</style>